export default __webpack_public_path__ + "static/media/mahindra.32c5aadd.ico";